import { HLocalStorage } from "@macashipo/mlib"
const getObj = HLocalStorage.getObj
const saveObj = HLocalStorage.saveObj
const getString = HLocalStorage.getString
const saveString = HLocalStorage.saveString
const initLocalStorage = HLocalStorage.initLocalStorage
export { getObj, getString, initLocalStorage, saveObj, saveString }
export default HLocalStorage
